// Combines `Array#map` and `Array#filter(_ != null)` into one step.
export default function mapExists<TElement, TResult>(
  array: TElement[],
  func: (item: TElement, index: number, array: TElement[]) => TResult | undefined | null
) {
  let indexAfterEnd = 0;
  const result: TResult[] = new Array(array.length);
  for (let index = 0; index < array.length; index += 1) {
    // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    const temp = func(array[index], index, array);
    if (temp != null) {
      result[indexAfterEnd] = temp;
      indexAfterEnd += 1;
    }
  }
  if (indexAfterEnd < result.length) {
    result.length = indexAfterEnd;
  }
  return result;
}
